import { render, staticRenderFns } from "./UpdatePasswordDialog.vue?vue&type=template&id=fdc5b9ec&scoped=true"
import script from "./UpdatePasswordDialog.vue?vue&type=script&lang=js"
export * from "./UpdatePasswordDialog.vue?vue&type=script&lang=js"
import style0 from "./UpdatePasswordDialog.vue?vue&type=style&index=0&id=fdc5b9ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdc5b9ec",
  null
  
)

export default component.exports